import { FC } from 'react';
import { alpha } from '@mui/material/styles';
import { Avatar, Box, Typography } from '@mui/material';
import { IconButtonAnimate } from '../../../../components/animate';
import { styles } from '../styles';
import UserDropdown from '~/sections/user-profile/UserDropdown';
import { DropdownViewOption, UserDataJSONAPI } from '~/sections/user-profile/types';

type Props = {
  user: UserDataJSONAPI | undefined;
  open: boolean;
  anchorEl: HTMLElement | null;
  handleOpen: (event: React.MouseEvent<HTMLElement>) => void;
  handleClose: () => void;
  viewOptions: DropdownViewOption[];
};

const AccountPopover: FC<Props> = ({
  user,
  open,
  anchorEl,
  handleOpen,
  handleClose,
  viewOptions,
}) => (
  <>
    <IconButtonAnimate
      onClick={handleOpen}
      sx={{
        p: 0,
        ...(open && {
          '&:before': {
            zIndex: 1,
            content: "''",
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            position: 'absolute',
            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
          },
        }),
      }}
    >
      <Avatar src={user?.attributes.avatar_url} alt={user?.attributes.last_name}>
        <img src="/icons/avatar_placeholder.svg" alt={user?.attributes.last_name} />
      </Avatar>
    </IconButtonAnimate>

    <Box sx={styles.box}>
      <Typography variant="subtitle2" noWrap>
        {user?.attributes?.first_name} {user?.attributes?.last_name}
      </Typography>
      <Typography variant="body2" sx={styles.text} noWrap>
        {user?.attributes?.role}
      </Typography>
    </Box>

    {open && (
      <UserDropdown viewOptions={viewOptions} anchorEl={anchorEl} handleClose={handleClose} />
    )}
  </>
);

export default AccountPopover;
